import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../lib/auth";

/**
 * AdminBlock — wraps merchant-only routes.
 *
 * Strict role isolation: an admin account is a platform operator, not a
 * merchant. If an admin lands on a merchant page (manually typed URL,
 * stale bookmark, etc.) we bounce them to /admin. While auth is still
 * resolving (`user === null`) we render nothing — no flash of merchant UI.
 */
export default function AdminBlock({ children }) {
  const { user } = useAuth();
  if (user === null) return null;
  if (user && user.is_admin) return <Navigate to="/admin" replace />;
  return children;
}
